var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 8.26829C3.33333 4.62746 6.32416 1.66663 9.99999 1.66663C13.6758 1.66663 16.6667 4.62746 16.6667 8.26829C16.6667 12.8308 10.7925 17.9175 10.5425 18.1316C10.3858 18.2658 10.1933 18.3333 9.99999 18.3333C9.80666 18.3333 9.61416 18.2658 9.45749 18.1316C9.20749 17.9175 3.33333 12.8308 3.33333 8.26829ZM9.99999 16.3716C8.60416 15.0516 4.99999 11.3458 4.99999 8.26829C4.99999 5.54746 7.24249 3.33329 9.99999 3.33329C12.7575 3.33329 15 5.54746 15 8.26829C15 11.3458 11.3958 15.0516 9.99999 16.3716ZM7.08333 7.91621C7.08333 6.30788 8.39166 4.99954 10 4.99954C11.6083 4.99954 12.9167 6.30788 12.9167 7.91621C12.9167 9.52454 11.6083 10.8329 10 10.8329C8.39166 10.8329 7.08333 9.52454 7.08333 7.91621ZM8.75 7.91621C8.75 8.60538 9.31083 9.16621 10 9.16621C10.6892 9.16621 11.25 8.60538 11.25 7.91621C11.25 7.22704 10.6892 6.66621 10 6.66621C9.31083 6.66621 8.75 7.22704 8.75 7.91621Z",
    fill: "#0E031D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4956_1689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 14,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 8.26829C3.33333 4.62746 6.32416 1.66663 9.99999 1.66663C13.6758 1.66663 16.6667 4.62746 16.6667 8.26829C16.6667 12.8308 10.7925 17.9175 10.5425 18.1316C10.3858 18.2658 10.1933 18.3333 9.99999 18.3333C9.80666 18.3333 9.61416 18.2658 9.45749 18.1316C9.20749 17.9175 3.33333 12.8308 3.33333 8.26829ZM9.99999 16.3716C8.60416 15.0516 4.99999 11.3458 4.99999 8.26829C4.99999 5.54746 7.24249 3.33329 9.99999 3.33329C12.7575 3.33329 15 5.54746 15 8.26829C15 11.3458 11.3958 15.0516 9.99999 16.3716ZM7.08333 7.91621C7.08333 6.30788 8.39166 4.99954 10 4.99954C11.6083 4.99954 12.9167 6.30788 12.9167 7.91621C12.9167 9.52454 11.6083 10.8329 10 10.8329C8.39166 10.8329 7.08333 9.52454 7.08333 7.91621ZM8.75 7.91621C8.75 8.60538 9.31083 9.16621 10 9.16621C10.6892 9.16621 11.25 8.60538 11.25 7.91621C11.25 7.22704 10.6892 6.66621 10 6.66621C9.31083 6.66621 8.75 7.22704 8.75 7.91621Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4956_1689)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.9006a18ddefcb7f8a724faf4eb93dd10.svg";
export { ForwardRef as ReactComponent };